import { ImageUrlWidget } from './image-url.widget';
import { ImageUploadWidget } from './image-upload.widget';
import { WidgetRegistry, DefaultWidgetRegistry } from "ngx-schema-form"
import { InputWidget } from './input.widget'
import { SelectWidget } from './select.widget';
import { RadioWidget } from './radio.widget'
import { CheckboxWidget } from './checkbox.widget';
import { NumberWidget } from './number.widget';
import { TextareaWidget } from "./textarea.widget";
import { CalendarWidget } from './calendar.widget';
import { HtmlEditorWidget } from './html.widget';
export class WidgetRegistryPrimeNG extends DefaultWidgetRegistry {
  constructor() {
    super();
    this.register('radio', RadioWidget);
    this.register('string', InputWidget);
    this.register('select', SelectWidget);
    this.register('boolean', CheckboxWidget);
    this.register('number', NumberWidget);
    this.register('textarea', TextareaWidget);
    this.register('calendar', CalendarWidget);
    this.register('html', HtmlEditorWidget);
    this.register('image-upload', ImageUploadWidget);
    this.register('image-url', ImageUrlWidget);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/WidgetRegistryPrimeNG.ts